import { useContext } from 'react'
import { ImagesContext } from '@/context'

export const useImages = () => {
  const ctx = useContext(ImagesContext)
  if (!ctx) throw new Error('useImages must be used within a useImagesProvider')
  return ctx
}
